import ZocoCheckAlertsSection from "../crmpostventa/zoco-check-alerts/ZocoCheckAlertsSection";

const PROCESS_SECTIONS = {
  "zoco-check": ZocoCheckAlertsSection,
  "terminal-sin-facturacion": {
    component: ZocoCheckAlertsSection,
    props: {
      detailLabel: "Sin facturación",
      searchPlaceholder: "Buscar por comercio, CUIT, terminal...",
      emptyMessage: "No hay procesos sin facturación pendientes.",
    },
  },
  "recupero-terminal": {
    component: ZocoCheckAlertsSection,
    props: {
      detailLabel: "Recupero",
      searchPlaceholder: "Buscar por comercio, CUIT, terminal...",
      emptyMessage: "No hay procesos de recupero pendientes.",
    },
  },
};

export const getProcessSection = (slug) => {
  const entry = PROCESS_SECTIONS[slug];
  if (!entry) return null;

  return typeof entry === "function"
    ? { component: entry, feedsRows: false, props: {} }
    : { feedsRows: false, props: {}, ...entry };
};

export default PROCESS_SECTIONS;
